import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=470a2d55&scoped=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"

import "./ForgotPasswordModal.vue?vue&type=style&index=0&id=470a2d55&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470a2d55"]])

export default __exports__